export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13772.b364bcc4.jpg";